import React from 'react';

export const ScribeIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22.000000pt"
        height="22.000000pt"
        viewBox="0 0 225.000000 225.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
          fill="white"
          stroke="#fff"
          strokeWidth="20"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M1237 2228 c-45 -42 -217 -268 -217 -285 0 -9 18 -36 40 -58 l41 -42
-373 -299 -373 -300 -92 -314 c-276 -939 -265 -897 -247 -914 12 -13 24 -12
87 5 137 38 1131 330 1139 335 4 3 141 171 304 375 l297 370 42 -41 c22 -22
48 -40 58 -40 21 0 292 213 301 237 5 13 -108 132 -471 496 -263 263 -486 483
-495 488 -12 7 -23 3 -41 -13z m476 -515 c342 -343 444 -450 434 -459 -6 -6
-54 -43 -106 -84 l-94 -72 -424 424 -425 425 83 107 c45 58 83 106 83 106 1 0
203 -201 449 -447z m-239 -242 l320 -320 -40 -50 c-21 -28 -154 -194 -294
-369 l-255 -319 -370 -108 c-689 -201 -675 -197 -673 -213 2 -10 -15 -21 -55
-35 -32 -10 -61 -17 -63 -14 -3 3 2 30 12 61 12 39 23 56 34 56 19 0 16 -7
217 680 l106 365 366 292 c201 161 368 293 371 293 3 0 149 -144 324 -319z"
          />
          <path
            d="M721 1026 c-49 -18 -106 -70 -130 -119 -28 -59 -28 -146 0 -205 l22
-44 -252 -252 c-138 -138 -251 -254 -251 -259 0 -4 7 -7 15 -7 8 0 15 -7 15
-15 0 -8 3 -15 7 -15 5 0 121 113 259 251 l252 252 44 -22 c59 -28 146 -28
205 0 116 56 165 196 109 314 -28 60 -56 87 -116 114 -51 23 -127 26 -179 7z
m170 -79 c99 -67 107 -203 16 -278 -116 -94 -299 18 -271 167 20 108 165 172
255 111z"
          />
        </g>
      </svg>
    </>
  );
};

export const ScribeNewIcon = () => {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 225.000000 225.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,225.000000) scale(0.100000,-0.100000)"
          fill="#22CCEE"
          stroke="#22CCEE"
          strokeWidth="20"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M1237 2228 c-45 -42 -217 -268 -217 -285 0 -9 18 -36 40 -58 l41 -42
-373 -299 -373 -300 -92 -314 c-276 -939 -265 -897 -247 -914 12 -13 24 -12
87 5 137 38 1131 330 1139 335 4 3 141 171 304 375 l297 370 42 -41 c22 -22
48 -40 58 -40 21 0 292 213 301 237 5 13 -108 132 -471 496 -263 263 -486 483
-495 488 -12 7 -23 3 -41 -13z m476 -515 c342 -343 444 -450 434 -459 -6 -6
-54 -43 -106 -84 l-94 -72 -424 424 -425 425 83 107 c45 58 83 106 83 106 1 0
203 -201 449 -447z m-239 -242 l320 -320 -40 -50 c-21 -28 -154 -194 -294
-369 l-255 -319 -370 -108 c-689 -201 -675 -197 -673 -213 2 -10 -15 -21 -55
-35 -32 -10 -61 -17 -63 -14 -3 3 2 30 12 61 12 39 23 56 34 56 19 0 16 -7
217 680 l106 365 366 292 c201 161 368 293 371 293 3 0 149 -144 324 -319z"
          />
          <path
            d="M721 1026 c-49 -18 -106 -70 -130 -119 -28 -59 -28 -146 0 -205 l22
-44 -252 -252 c-138 -138 -251 -254 -251 -259 0 -4 7 -7 15 -7 8 0 15 -7 15
-15 0 -8 3 -15 7 -15 5 0 121 113 259 251 l252 252 44 -22 c59 -28 146 -28
205 0 116 56 165 196 109 314 -28 60 -56 87 -116 114 -51 23 -127 26 -179 7z
m170 -79 c99 -67 107 -203 16 -278 -116 -94 -299 18 -271 167 20 108 165 172
255 111z"
          />
        </g>
      </svg>
    </>
  );
};
